import React, { useRef, useEffect } from 'react';
import './InputWithGoogleMapApi.css';


function GoogleAutocomplete({ type, dispatch }) {
    const autocompleteInputRef = useRef(null);
    const google = window.google;

    useEffect(() => {
        if (!google) return;

        // Specifikujte typy a fields pro omezení dat
        const autocomplete = new google.maps.places.Autocomplete(autocompleteInputRef.current, {
            fields: ['address_components', 'geometry'], // Zde specifikujte, která data chcete získat
        });

        autocomplete.addListener("place_changed", () => {
            const selectedPlace = autocomplete.getPlace();
         
            if (selectedPlace.geometry) {
                const gps = { lat: selectedPlace.geometry.location.lat(), lng: selectedPlace.geometry.location.lng() };
                const adres =
                    selectedPlace.address_components[1].short_name +
                    ", " +
                    selectedPlace.address_components[0].short_name +
                    ", " +
                    selectedPlace.address_components[2].short_name;
                dispatch({ type: type, payload: { gps: gps, adres: adres } });
            } else {
                alert("neshoda adresy");
            }
        });
    }, [google]);



    return (
        <div>
            <input ref={autocompleteInputRef} type="text" placeholder="Zadejte adresu..." className='InputWithGoogleMapApi'/>
        </div>
    );
}



export default GoogleAutocomplete;
